<template>
  <div class="myteam">
    <div class="info" v-if="list.length>0">
      温馨提示：本应用不提供照片的长久存储功能，团体照截止时间之日起30天会自动删除，请尽早提取！
    </div>
    <div class="listwrap">
      <teamitem v-for="(item, index) in list"
                :key="item.id"
                :info="item"
                :idx="index"
                @onTakePhoto="onTakePhoto"></teamitem>
    </div>
    <search-rule v-if="list.length===0&&!loadingTxt" :searchStatus="6" searchCot='您此时还没有创建任何团体'></search-rule>
    <tq v-if="showFlag"
        :team="selObj"
        @onCloseWrap="closeFlagFn"
        @onHandleInfo="onHandleInfo"
        :noops="noops"
        @onGoPhoto="onGoPhoto"></tq>
    <photo :showFlag="photoFlag"
           :collectInfo="selObj"
           @onControlPhoto="photoFlag=false"
           @onRruleDetail="photoFlag=false"></photo>
    <qrcode></qrcode>
  </div>
</template>

<script>
import teamitem from '@/components/teamitem'
import searchRule from '@/components/searchRule/searchRule'
import teamquesion from '@/components/teamquestion'
import photo from '@/components/photo/photo'
import { mapState, mapActions, mapMutations } from 'vuex'
import qrcode from '@/components/qrcode/qrcode'
export default {
  data () {
    return {
      list: [],
      showFlag: false,
      selObj: {},
      noops: true,
      photoFlag: false,
      idx: -1
    }
  },
  components: {
    teamitem,
    searchRule,
    tq: teamquesion,
    photo,
    qrcode
  },
  computed: {
    ...mapState(['loadingTxt', 'actiBol'])
  },
  deactivated () {
    this.showFlag = false
    this.photoFlag = false
  },
  activated () {
    if (!this.actiBol) {
      return
    }
    this.getlist()
  },
  created () {
    this.$bus.on('mt_modifytime', this.modifytime)
    this.$bus.on('mt_backphoto', this.backphoto)
    this.$bus.on('mt_actualnum', this.actualnum)
  },
  destroyed () {
    this.$bus.off('mt_modifytime')
    this.$bus.off('mt_backphoto')
    this.$bus.off('mt_actualnum')
  },
  methods: {
    ...mapActions(['getOwnListA']),
    ...mapMutations(['setMakePhotoInfo']),
    modifytime (...args) {
      console.log('修改时间啦')
      this.list[args[0]].end_time = args[1]
    },
    backphoto (...args) {
      console.log('打回图片啦')
      this.list[args[0]].actual_quantity = args[1]
    },
    actualnum (...args) {
      console.log('人数变化啦')
      const project_no = args[0]
      const arr = this.list.map((item) => {
        let num = item.actual_quantity
        return {
          ...item,
          ...item.project_no === project_no && {
            actual_quantity: ++num
          }
        }
      })
      this.list = arr
    },
    getlist () {
      this.getOwnListA().then(res => {
        const { data } = res
        this.list = data
      })
    },
    closeFlagFn () {
      this.showFlag = false
      this.noops = true
    },
    onTakePhoto (idx) {
      console.log('idx:::', idx)
      const { list } = this
      this.idx = idx
      const info = list[idx]
      this.showFlag = true
      this.selObj = info
    },
    onHandleInfo (obj) {
      const { keyname, value } = obj
      const { information = {}, extra_information } = this.selObj
      information[keyname] = value
      !value && delete information[keyname]
      const bol = extra_information.length !== Object.keys(information).length
      this.selObj.information = information
      this.noops = bol
    },
    onGoPhoto () {
      const { selObj } = this
      selObj.idx = this.idx
      this.setMakePhotoInfo(selObj)
      this.photoFlag = true
      this.noops = true
      this.showFlag = false
    }
  }
}
</script>

<style scoped>
.myteam{
  background-color: #F5F7FA;
  box-sizing: border-box;
  min-height: 100%;
}
.listwrap{
  box-sizing: border-box;
  padding:0 .32rem 0.16rem;
}
.info{
  background-color: rgba(252, 156, 29, 0.1);
  font-size: .24rem;
  color:#FC9C1D;
  box-sizing: border-box;
  padding:.16rem .4rem;
  margin-bottom: .32rem;
  line-height: .36rem;
}
</style>
